<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ProjectScheduledLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectScheduledLifecycleSetter";
    import { MonthPicker } from 'vue-month-picker'
    import { MonthPickerInput } from 'vue-month-picker'
    import { MonthPickerDate } from "@common/Components/MonthPickerDialog";
    import { MonthYearHelpers } from "@common/types";


    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        },
        components: {
            MonthPicker, MonthPickerInput
        },
    })
    export default class ProjectScheduledLifecycleSetter extends Vue
    {
        get vm(): ProjectScheduledLifecycleSetterViewModel { return this.$props.viewModel as ProjectScheduledLifecycleSetterViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get startDate(): MonthPickerDate | null { return this.vm.startDate; }
        set startDate(val: MonthPickerDate) { this.vm.startDate = val; }

        get isStartDateSet(): boolean { return this.startDate && this.startDate.monthIndex && this.startDate.year; }

        get isStartDateValid(): boolean { return MonthPickerDate.isValid(this.startDate, this.vm.minStartDate, this.vm.maxStartDate); }

        get startDateLabel(): string | null
        {
            if (!this.isStartDateSet) return null;

            const date = new Date(this.startDate.year, this.startDate.monthIndex - 1, 1); // Month index is 0-based
            return new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
        }

        isStartDateMonthPickerVisible: boolean = false;

        onStartDateChange(date: MonthPickerDate) 
        {
            this.startDate = date;
        }

        confirm()
        {
            if (this.isStartDateSet && this.isStartDateValid)
            {
                const date = MonthYearHelpers.build(this.vm.startDate.year, this.vm.startDate.monthIndex);
                this.$emit("confirm", this.vm.projectId, date);
            }
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Change Project Lifecycle to Scheduled</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p>
                            You are about to change the project lifecycle to the <strong>Scheduled</strong> stage.
                            Please ensure the start date is set and valid.
                        </p>

                        <div class="form-group">
                            <label>Start date:</label>
                            <div class="input-group">
                                <input :value="startDateLabel" placeholder="Select a start date" type="text" class="form-control pointer bg-white" readonly @click="isStartDateMonthPickerVisible = !isStartDateMonthPickerVisible" />
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" @click="isStartDateMonthPickerVisible = !isStartDateMonthPickerVisible">
                                        <i class="fa-regular fa-calendar" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                            <p class="text-danger" v-if="!isStartDateSet || !isStartDateValid">
                                A start date is required and cannot be in the past.
                            </p>
                            <month-picker v-show="isStartDateMonthPickerVisible"
                                          @change="onStartDateChange"
                                          :min-date="vm.minStartDate"
                                          :max-date="vm.maxStartDate"
                                          :default-month="vm.defaultMonth"
                                          :default-year="vm.defaultYear" />
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="button" @click="confirm" class="btn btn-primary" :disabled="!isStartDateSet || !isStartDateValid">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

